import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [장비등록 > 네트워크 > 서비스] 선택한 obj에 해당하는 자원을 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getSvcForRscTreeData(params) {
    return axios.post(`${baseUrl}/settings/device-registration-svc/get-${params.rsctypeId.toLowerCase().replace('_', '')}-svc-for-rsc-tree-data.do`, params);
  },
  /**
   * [장비등록 > 네트워크 > 서비스] 서비스를 등록한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  insertService(params) {
    return axios.post(`${baseUrl}/settings/device-registration-svc/insert-service.do`, params);
  },
  /**
   * [장비등록 > 네트워크 > 서비스] 서비스 목록을 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getServiceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-svc/get-service-list.do`, params);
  },
  /**
   * [장비등록 > 네트워크 > 서비스] 최근 3일 안에 등록된 서비스 카운트 조회
   * @author Song
   * @return {Object} [response 객체]
   */
  getRecentServiceCount() {
    return axios.get(`${baseUrl}/settings/device-registration-svc/get-recent-service-count.do`);
  },
  /**
   * [장비등록 > 네트워크 > 서비스] 해당 서비스와 연결된 장비 리스트를 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getTargetServiceConfig(params) {
    return axios.post(`${baseUrl}/settings/device-registration-svc/get-target-service-config.do`, params);
  },
  /**
   * [장비등록 > 네트워크 > 서비스] 해당 서비스와 연결된 자원 리스트를 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getTargetServiceObjRscKey(params) {
    return axios.post(`${baseUrl}/settings/device-registration-svc/get-target-service-obj-rsc-key.do`, params);
  },
  /**
   * [장비등록 > 네트워크 > 서비스] 서비스를 수정한다. ( 서비스 이름, 설명, 장비연결 리스트, 자원 연결리스트 )
   * @author Song
   * @return {Object} [response 객체]
   */
  updateServiceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-svc/update-service-list.do`, params);
  },
  /**
   * [장비등록 > 네트워크 > 서비스] 서비스 리스트를 삭제한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  deleteServiceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-svc/delete-service-list.do`, params);
  },
  /**
   * [장비등록 > 네트워크 > 서비스] 서비스 - 관리여부를 수정한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  updateServiceManageData(params) {
    return axios.post(`${baseUrl}/settings/device-registration-svc/update-service-manage-data.do`, params);
  },
  /**
   * [장비등록 > 네트워크 > 서비스] 서서비스에서 선택한 장비들의 자원들을 보여주는 동적트리 => 정적트리로 표현 변경
   * @author Song
   * @return {Object} [response 객체]
   */
  getSvcRscByStaticTree(params) {
    return axios.post(`${baseUrl}/settings/device-registration-svc/get-svc-rsc-by-static-tree.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/device-registration-svc.js